import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Col } from 'reactstrap';
import moment from 'moment';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import ReactLoading from 'react-loading';
import Countdown from "react-countdown";
import {
  Row,
  Button
} from "reactstrap"

/* COMPONENTS */
import ModalOutOfStock from '../../../../Modals/ModalOutOfStock';
import ButtonSnapPay from '../../../../Forms/ButtonSnapPay';
import PaymentStatusCard from './PaymentStatusCard';
import SuccessResult from "../SuccessResult"
import FailedResult from "../FailedResult"
import PendingResult from "../PendingResult"

/* UTILS | HELPERS */
import { isFromKickApp, emptyImage, getCloudImageUrl, convertToRupiah } from "../../../../../utils";
import { PAYMENT_LOGOS } from "../../../../../constants/paymentMethods"
import {
  renderMessage,
  getHeaderText,
  getStatusIcon,
  getSelectedPayment
} from "../paymentHelpers"

/* ASSETS */
import Copy from "../../../../../images/copyIcon.png"
import ContinueArrow from "../../../../../images/shopping-cart-continue.png";
import PendingIcon from '../../../../../images/stopwatch.png';
import ErrorIcon from '../../../../../images/stopwatch.png';
import TimesUpIcon from '../../../../../images/icons/times-up.png';
import SuccessIcon from '../../../../../images/icons/success.png';
import SuccessIcon2 from "../../../../../images/kick-credit-payment-success.jpg";
import FailedIcon from '../../../../../images/kredivo-payment-declined.png';

moment.locale("en");

const NOT_CONFIRM_PAYMENT_MSG = 'COMPLETE YOUR PAYMENT';

const HAS_CONFIRM_PAYMENT_MSG = 'SEE INSTRUCTIONS';

const renderer = ({ days, hours, minutes, seconds, completed, ...props }) => {
  const newHours = days * 24 + hours;
  return (
    <p>
      {newHours === 0 ? "00 " : newHours}:{minutes === 0 ? " 00 " : minutes}:{seconds === 0 ? " 00" : seconds}
    </p>
  );
};

/* 
  const PendingMessage = props => (
    <Col xs={12} md={12} className="section note text-center">
      {
        !props.hasConfirm ?
          <p>Next step, complete and process your order by clicking this button.</p>
          : null
      }
      <p>Please complete your payment before <strong>{moment(props.expire).format('dddd, LL HH:mm')}</strong>.</p>
    </Col>
  )

  const VerifiedPaymentMessage = props => (
    <Col xs={12} md={12} className="section note text-center">
      <p>Holding on, your order is being processed by Admin. Please wait until Admin confirm your payment. ETA (1x24 hour).</p>
    </Col>
  )

  const ExpiredMessage = () => (
    <Col xs={12} md={12} className="section note text-center">
      <p><strong>Oops, </strong>your order has been expired. You cannot confirm your payment. Try to re-order again!</p>
      <p>If you have any questions about your order, please contact our team by email to info@kickavenue.com. Please put your invoice number into your subject email.</p>
    </Col>
  )

  const ErrorMessage = ({ error }) => (
    <Col xs={12} md={12} className="section note text-center">
      <p><strong>Oops, </strong>we got unhandled issues when try processing your payment.</p>
      <p>Or if you have any questions about your order, please contact our team by email to info@kickavenue.com. Please put your invoice number into your subject email.</p>
    </Col>
  )

  const CancelledMessage = () => (
    <Col xs={12} md={12} className="section note text-center">
      <p><strong>Oops, </strong>your order has been cancelled. Try to re-order again!</p>
      <p>If you have any questions about your order, please contact our team by email to info@kickavenue.com. Please put your invoice number into your subject email.</p>
    </Col>
  )

  const SucceededMessage = () => (
    <Col xs={12} md={12} className="section note text-center">
      <p>Thank you for completing your payment. Your order will be process.</p>
      <p>If you have any questions about your order, please contact our team by email to info@kickavenue.com. Please put your invoice number into your subject email.</p>
    </Col>
  )
*/



const PendingMessage = props => (
  <div className="payment-result-message-wrapper">
    {
      !props.hasConfirm ?
        <p>Next step, complete and process your order by clicking this button.</p>
        : null
    }
    <p>Please complete your payment before <strong>{moment(props.expire).format('dddd, LL HH:mm')}</strong>.</p>
  </div>
)

const VerifiedPaymentMessage = props => (
  <div className="payment-result-message-wrapper">
    <p>Holding on, your order is being processed by Admin. Please wait until Admin confirm your payment. ETA (1x24 hour).</p>
  </div>
)

const ExpiredMessage = () => (
  <div className="payment-result-message-wrapper">
    <p><strong>Oops, </strong>your order has been expired. You cannot confirm your payment. Try to re-order again!</p>
    <p>If you have any questions about your order, please contact our team by email to <a href="mailto:info@kickavenue.com" title="Mail to info@kickavenue.com">info@kickavenue.com</a>. Please put your invoice number into your subject email.</p>
  </div>
)

const ErrorMessage = ({ error }) => (
  <div className="payment-result-message-wrapper">
    <p><strong>Oops, </strong>we got unhandled issues when try processing your payment.</p>
    <p>Or if you have any questions about your order, please contact our team by email to <a href="mailto:info@kickavenue.com" title="Mail to info@kickavenue.com">info@kickavenue.com</a>. Please put your invoice number into your subject email.</p>
  </div>
)

const CancelledMessage = () => (
  <div className="payment-result-message-wrapper">
    <p><strong>Oops, </strong>your order has been cancelled. Try to re-order again!</p>
    <p>If you have any questions about your order, please contact our team by email to <a href="mailto:info@kickavenue.com" title="Mail to info@kickavenue.com">info@kickavenue.com</a>. Please put your invoice number into your subject email.</p>
  </div>
)

const SucceededMessage = () => (
  <div className="payment-result-message-wrapper">
    <p>Thank you for completing your payment. Your order will be process.</p>
    <p>If you have any questions about your order, please contact our team by email to <a href="mailto:info@kickavenue.com" title="Mail to info@kickavenue.com">info@kickavenue.com</a>. Please put your invoice number into your subject email.</p>
  </div>
)

const MessageCard = props => (
  <div>
    {props.children}
    <Col xs={12} className="button-wrapper full-width-wrapper">
      <ButtonSnapPay
        ref={props.buttonPayRef}
        snapToken={props.trxTkn}
        disabled={props.isLoading}
        hide={!props.hasAction}
        className={"btn-green bold"}
        color="success"
        size="lg"
        block
        redirectUrl={props.redirectUrl}
        onSuccess={props.onSnapSuccess}
        onPending={props.onSnapPending}
        onError={props.onSnapError}
        onClose={props.onSnapClose}
      >
        {
          props.isLoading ?
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <ReactLoading type={'bars'} height={20} width={20} color="#fff" />
              <span style={{ marginLeft: '.5rem' }}>
                PLEASE WAIT
              </span>
            </div>
            : props.actionText
        }
      </ButtonSnapPay>
      <Link
        to="/"
        className={classNames("btn-green bold btn btn-lg btn-block btn-success", { 'd-none': props.hasAction })}
      >
        BACK TO HOME
      </Link>
    </Col>
  </div>
)


class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      _snapResponse: {
        data: null,
        error: null
      },
      _isOpenAlert: false,
      _paymentStatus: props.dataPayment.status,
      _paymentStep: props.trxId !== null ? 2 : 1,
      _bankCode: props.vaType,
      _vaNumber: props.vaNumber,
      _isExpired: props.dataPayment.expired,
      // isExpired: false,
      _isAbleToConfirm: ['PENDING', 'VERIFYING_BID'].includes(props.dataPayment.status) && !props.dataPayment.expired
      // isAbleToConfirm: true
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isLoading && !this.props.isLoading) {
      this.setState({
        _paymentStep: this.props.trxId !== null ? 2 : 1,
        _vaNumber: this.props.vaNumber,
        _bankCode: this.props.vaType,
      })
    }
  }

  _handleOnSuccess = async (r) => {
    await this.setState({
      _snapResponse: {
        ...this.state._snapResponse,
        data: { ...r },
        error: null
      },
      _paymentStatus: 'COMPLETED',
      _isAbleToConfirm: false,
      _isExpired: false
    })
    //TODO: Save token cc;
    if (r.saved_token_id) {
      this.props.onSaveTokens({
        id: r.saved_token_id,
        expired_at: r.saved_token_id_expired_at
      })
    }
  }

  _handleOnPending = (r) => {
    const {
      transaction_id,
      payment_type,
      va_numbers,
      permata_va_number,
      bni_va_number,
      bca_va_number,
      bill_key,
      biller_code
    } = r;
    let { _vaNumber, _trxId, _bankCode } = this.state;
    if (transaction_id) {
      _trxId = transaction_id;
    }
    if (payment_type === 'echannel') {
      _vaNumber = `${biller_code} ${bill_key}`;
      _bankCode = 'MANDIRI';
    }
    else {
      if (va_numbers && va_numbers.length) {
        _vaNumber = va_numbers[0].va_number;
        _bankCode = va_numbers[0].bank.toUpperCase();
      }
      else if (permata_va_number) {
        _vaNumber = permata_va_number;
        _bankCode = 'PERMATA';
      }
      else if (bni_va_number) {
        _vaNumber = bni_va_number;
        _bankCode = 'BNI';
      }
      else if (bca_va_number) {
        _vaNumber = bca_va_number;
        _bankCode = 'BCA';
      }
    }
    this.setState({
      _snapResponse: {
        ...this.state._snapResponse,
        data: { ...r },
        error: null
      },
      _paymentStep: 2,
      _vaNumber,
      _bankCode
      // _vaNumber: '031007280231383'
    })
  }

  _handleOnError = (e) => {
    const { status_code } = e;
    this.setState({
      _snapResponse: {
        ...this.state._snapResponse,
        error: { ...e }
      },
      _paymentStatus: parseInt(status_code) === 407 ? 'EXPIRED' : 'ERROR',
      _isAbleToConfirm: false
    })
  }

  _renderMessage = () => {
    switch (this.state._paymentStatus) {
      case 'PENDING':
      case 'VERIFYING_BID': return this.state._isExpired ? <ExpiredMessage /> : <PendingMessage hasConfirm={this.state._paymentStep === 2} expire={this.props.expire} />;
      case 'VERIFYING_PAYMENT': return <VerifiedPaymentMessage />;
      case 'EXPIRED': return <ExpiredMessage />;
      case 'COMPLETED': return <SucceededMessage />;
      case 'REJECTED':
      case 'PENDING_REFUND':
      case 'REFUNDED':
      case 'CANCELLED': return <CancelledMessage />;
      default: return <ErrorMessage error={this.state._snapResponse.error} />;
    }
  }

  _handleOnToggleAlert = () => {
    this.setState({ _isOpenAlert: !this.state._isOpenAlert })
  }

  _handleOnSubmitAlert = async (e) => {
    await this._handleOnToggleAlert();
    this.buttonPayRef?._handleOpenSnap()
  }

  _handleExpiredCountdown = () => {
    const { _vaNumber } = this.state;
    this.setState({
      _isExpired: true,
      _vaNumber: _vaNumber && _vaNumber.split('').map((c, index) => {
        if (index > 2) return 'X';
        return c;
      }).join('')
    })
  }

  // getStatusIcon = (paymentStatus, isExpired) => {
  //   switch (paymentStatus) {
  //     case 'PENDING':
  //     case 'VERIFYING_BID': return isExpired ? TimesUpIcon : PendingIcon;
  //     case 'VERIFYING_PAYMENT': return PendingIcon;
  //     case 'EXPIRED': return TimesUpIcon;
  //     case 'COMPLETED': return SuccessIcon;
  //     // case 'REJECTED':
  //     // case 'PENDING_REFUND':
  //     // case 'REFUNDED':
  //     // case 'CANCELLED': return ErrorIcon;
  //     default: return ErrorIcon;
  //   }
  // }

  // getHeaderText = (paymentStatus, isExpired) => {
  //   switch (paymentStatus) {
  //     case 'PENDING':
  //     case 'VERIFYING_BID': return isExpired ? 'Your payment has been expired.' : 'Waiting your payment confirmation.';
  //     case 'VERIFYING_PAYMENT': return 'Your payment is being processed by Admin.';
  //     case 'EXPIRED': return 'Your payment has been expired.';
  //     case 'COMPLETED': return 'Hooray! You have successfully purchased!';
  //     case 'REJECTED':
  //     case 'PENDING_REFUND':
  //     case 'REFUNDED':
  //     case 'CANCELLED': return 'Your payment has been cancelled.';
  //     default: return 'We got something issues when processing your payment.';
  //   }
  // }

  // getSelectedPayment = (paymentMethod, bankCode) => {
  //   switch (paymentMethod) {
  //     case 'virtual_account': return bankCode ? `${bankCode} - Virtual Account` : 'Virtual Account';
  //     case 'credit_card': return 'Credit Card';
  //     case 'kredivo': return 'Kredivo';
  //     case 'full_wallet': return 'Kick Credit';
  //     case 'gopay': return 'Gopay';
  //     default: return 'Bank Transfer';
  //   }
  // }

  renderLeftSection = () => {
    const {
      invoice_number,
      status,
      expired,
      expiry,
      bank_code,
      payment_method,
      total_amount,
      invoice_url,
      total_adjusted_amount
    } = this.props.dataPayment

    const {
      _vaNumber
    } = this.state

    const payment_logo = PAYMENT_LOGOS[`${bank_code ? bank_code.toLowerCase() : payment_method}`]

    if (expired) {
      return <FailedResult
        header_text={getHeaderText(status, expired)}
        orderDetailsData={this.props.orderDetailsData}
      >
        {renderMessage(
          status,
          expired,
          this.state._snapResponse.error,
          this.state._paymentStep,
          expiry
        )}
      </FailedResult>
    }

    switch (status) {
      case "COMPLETE":
      case "COMPLETED":
        return <SuccessResult orderDetailsData={this.props.orderDetailsData} invoice_number={invoice_number} />
      case "VERIFYING_BID":
      case "PENDING":
        return (
          <PendingResult
            userCurrency={this.props.userCurrency}
            invoice_number={invoice_number}
            status={status}
            header_text={getHeaderText(status, expired)}
            status_icon={getStatusIcon(status, expired)}
            expiry={expiry}
            bank_code={bank_code}
            payment_logo={getCloudImageUrl(payment_logo)}
            handleExpire={this._handleExpiredCountdown}
            payment_method_text={getSelectedPayment(payment_method, bank_code)}
            va_number={_vaNumber}
            amount_to_be_paid={parseInt(total_adjusted_amount)}
            invoice_url={invoice_url}
            onSuccess={this._handleOnSuccess}
            onPending={this._handleOnPending}
            onError={this._handleOnError}
            onClose={this._handleOnToggleAlert}
            snapToken={this.props.trxTkn}
            isMitrans={true}
            orderDetailsData={this.props.orderDetailsData}
            buttonText={
              this.props.isLoading
                ? "PLEASE WAIT" :
                this.state._paymentStep === 2
                  ? HAS_CONFIRM_PAYMENT_MSG : NOT_CONFIRM_PAYMENT_MSG
            }
          />
        )
      default:
        return (
          <FailedResult
            header_text={getHeaderText(status, expired)}
            orderDetailsData={this.props.orderDetailsData}
          >
            {renderMessage(
              status,
              expired,
              this.state._snapResponse.error,
              this.state._paymentStep,
              expiry
            )}
          </FailedResult>
        )
    }
  }

  render() {

    const {
      actual_total_amount,
      wallet_usage,
      invoice_number,
      status,
      expired
    } = this.props.dataPayment || {}


    return (
      <>
        <ModalOutOfStock
          isOpen={this.state._isOpenAlert}
          onToggle={this._handleOnToggleAlert}
          message="Oops! You have not completed your payment. Would you like to complete it now?"
          onButtonPrimaryClick={this._handleOnSubmitAlert}
          buttonPrimaryText="Proceed to payment completion"
          isCloseable
        />
        {/* <div>
            <PaymentStatusCard
              expiredAt={this.props.expire}
              paymentStatus={this.state._paymentStatus}
              isExpired={this.state._isExpired}
              paymentMethod={this.props.dataPayment.payment_method}
              bankCode={this.state._bankCode}
              vaNumber={this.state._vaNumber}
              onExpired={this._handleExpiredCountdown}
            />
            <MessageCard
              buttonPayRef={input => this.buttonPayRef = input}
              isLoading={this.props.isLoading}
              hasAction={this.state._isAbleToConfirm}
              actionText={this.state._paymentStep === 2 ? HAS_CONFIRM_PAYMENT_MSG : NOT_CONFIRM_PAYMENT_MSG}
              trxTkn={this.props.trxTkn}
              redirectUrl={this.props.dataPayment.invoice_url}
              onSnapSuccess={this._handleOnSuccess}
              onSnapPending={this._handleOnPending}
              onSnapError={this._handleOnError}
              onSnapClose={this._handleOnToggleAlert}
            >
              {this._renderMessage()}
            </MessageCard>
          </div> */}
        {this.renderLeftSection()}
      </>
    )
  }
}

export default Footer;